import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ItemList from "../components/ItemList.jsx";

function createMarkup(htmlstring) { return {__html: htmlstring}; }

export default class StoryCard extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    const { index, loading } = this.props;

    if (0 == index && !loading) {
      this.itemWrapper.focus();
    }
  }
 
  render() {
    const { abstract, authors, displaytypename, publisheddate, displaydate, title, type, url } = this.props;

    const ariaLabel = "Read the full article on " + title;

    const cardClass = classNames("digest-card story-card");

    if (displaytypename == 'Web Story' && new Date() < new Date(displaydate)) {
      console.log('date is in the future');
      return null;
    }

    return (
      <div className={cardClass}>
        { title && <div className="digest-card__title"><a ref={el => (this.itemWrapper = el)} href={ url }>{ title }</a></div>}
        { (displaydate || displaytypename ) && <div className="digest-card__date">
          { displaydate && <span className="digest-card__label">
              { displaydate }
            </span> }
          { displaydate && displaytypename && <span> - </span> }
          { displaytypename && <span className="digest-card__label">
              { displaytypename }
            </span> }
          </div> }
          { authors && authors.length > 0 && <ItemList items={authors} label="Author(s)"  showMoreButton={authors.length > 9} /> }
          { abstract && <div className="digest-card__summary">{ abstract }...</div> }
      </div>
    );
  }
}

const { array, bool, func, number, string } = PropTypes;

StoryCard.propTypes = {
  abstract: string,
  authors: array,
  displaytypename: string,
  index: number,
  loading: bool,
  newthisweek: bool,
  publisheddate: string,
  displaydate: string,
  title: string,
  type: string,
  url: string
};
